export default __webpack_public_path__ + "static/media/logout.b9556872.svg";